import styled from "styled-components";
import { buildColor } from "@tvg/design-system/src/_static/colorPalette";

export const Container = styled.button`
  width: 56px;
  height: 157px;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  right: 0;
  bottom: 298px;
  background-color: ${buildColor("blue_accent", "500")};
  border-radius: 4px 0 0 4px;

  &:hover {
    cursor: pointer;
  }

  span {
    transform: rotate(270deg);
    font-size: 18px;
    font-weight: 700;
    color: ${buildColor("white", "900")};
    margin-top: 40px;
  }
`;

export const IconContainer = styled.div`
  margin-top: 12px;
`;

export const Divider = styled.hr`
  width: 40px;
  height: 1px;
  background-color: ${buildColor("blue_accent", "600")};
  margin: 12px 0 0 0;
  border: 0;
`;
